'use client';

import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';

import { oddsPageAtom } from '@/atoms/odds-page';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { CdnImg } from '@/features/cdn-img';

export interface LeagueLogoProps {
	leagueId: number;
}

export const LeagueLogo = ({ leagueId }: LeagueLogoProps) => {
	const defaultImage = '/images/common/league_flag.png';
	const [imageSrc, setImageSrc] = useState<string>(defaultImage);
	const { SiteConfigsData } = useGetSiteConfigs();
	const oddsData = useAtomValue(oddsPageAtom);

	const enableImageServer = SiteConfigsData?.EnableImageServer;
	const enableFilterSaba = SiteConfigsData?.EnableFilterSaba;

	useEffect(() => {
		if (!enableImageServer) {
			setImageSrc(defaultImage);
			return;
		};

		const leagueNameSplitArray = oddsData?.leagueNameMap.get(leagueId)?.split('|') ?? [];
		const fileName = leagueNameSplitArray.length > 1 && !enableFilterSaba 
			? leagueNameSplitArray[1] 
			: '0';

		if (fileName !== '0') {
			setImageSrc(`/leagueimg/${fileName}`);
		} else {
			setImageSrc(defaultImage);
		}
	}, [enableImageServer, enableFilterSaba, leagueId]);

	const handleImageError = () => {
		setImageSrc(defaultImage);
	};
	
	return (
		<CdnImg
			className="league-logo"
			isGalaxyFolder={imageSrc === defaultImage}
			src={imageSrc}
			onError={handleImageError}
			alt=""
			width={18}
			height={18}
		/>
	);
};